module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The dark of night lay thick in the garden of the lavish Hollywood Hills estate where two shadowed figures conversed in low tones. Both were men. One was tall, broad and physical; the other was smooth, arrogant and cerebral.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you sure? Absolutely sure?” the smooth one demanded, sounding less smooth than usual as his eyes pierced the darkness to bead mercilessly at his companion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She wasn’t in that car,” the tall one insisted quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You said she was. I buried her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You buried ashes of what we thought was her. We were wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The smooth one’s nostrils flared, but he kept his voice low. “And how can you be sure it wasn’t her?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“One of our men heard talk around the coroner’s office. There was no evidence of a body, charred or otherwise. A burned purse and shoes, but no body. Unofficially, of course. Officially, at least as far as the heat’s concerned, she’s dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The arrogant one cursed under his breath. He pulled a pack of cigarettes from his pocket and barely had time to raise one to his mouth when the underling snapped a match with his thumbnail and lit it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("“No body,” he muttered, squaring his shoulders. “So she got away.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The physical one had enough sense to keep still. He knew what was to come, knew he had his work cut out for him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want her found,” the smooth one growled. “I want her found "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("now.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Still the physical one remained silent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She didn’t have any family, at least none she ever told me about. She wasn’t in touch with anyone else, and her friends were mine.” A long drag on the cigarette momentarily brightened its glowing red tip. “She must have had help.” Smoke curled out with the words and dissipated into the air. “New identity, new location, money…. Damn it,” he gritted out as the wheels of his mind turned, “she sold the jewels. There wasn’t any burglary. The bitch took the jewels herself and sold them!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll find her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Damn right you will. Half a million in diamonds and rubies, not to mention another hundred thou in furs—no woman can steal like that from me!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you want me to bring her back?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The tall man’s boss pondered that as he stroked the closely shaved skin above his lip. When he spoke, his voice was low once more and as dark as the night. “She’s a thief. And a traitor. I’ve given her a funeral fit for a queen. I won’t suffer the embarrassment of having her materialize from the grave.” He paused for a moment before continuing smoothly, arrogantly, cerebrally, in his own perverted way. “She’s dead. That’s how I want her. Make her squirm first. Let her know that I know what she’s done. Get the jewels and whatever else you can from her. Then see that she’s buried, this time with an unmarked stone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("Tossing the cigarette to the grass, he ground it out beneath the sole of his imported leather shoe. Then he straightened his silk evening jacket, thrust out his chin and walked calmly, coolly, back toward the house.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abd8731a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Prologue.vue
// module id = 72
// module chunks = 0